var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Panel',{staticClass:"add-block-cover d-flex justify-content-center align-items-center p-5 cursor-pointer",attrs:{"variant":[
    'transparent',
    'stroked',
    'stroked-popover-bg',
    'stroked-dashed',
    'rounded-large' ]}},[_c('Icon',{staticClass:"d-block text-center h-mr-3",attrs:{"name":"add","width":"22","fill":"white"}}),_c('TextBlock',{attrs:{"size":0.875}},[_c('strong',[_vm._v(_vm._s(_vm.$t('_web_tournament_stage_add-group-btn', 'Add Group')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }